import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { withRouter } from 'react-router-dom';

import { useActiveForm } from '@/components/form/ActiveSwitch';
import FormWrapper from '@/components/form/Wrapper';
import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import Form from '../components/Form';
import Heading from '../components/Heading';
import { IntegrationProvider, useIntegrationStore } from '../store';

const IntegrationPropTypes = {
  match: PropTypes.object,
}

const IntegrationForm = withRouter(({ match: { params: { id } } }) => {
  const { collection: { item, useLoad, useSubmit, reset } } = useIntegrationStore()
  const { handleSuccess, handleError } = useAppAlert()
  const { active, setActive } = useActiveForm(item)

  useLoad(id)
  const handleSubmit = useSubmit()

  const handleClose = useCallback(() => {
    history.push('/settings/integrations');
  }, [])

  const handleSubmitAndRedirect = useCallback(async payload => {
    try {
      const { id } = await handleSubmit({ ...payload, active })
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Integration ${message}.`);

      if (payload.id) {
        reset()
        history.push(`/settings/integrations`)
      } else {
        reset()
        history.push(`./${id}`)
      }
    } catch (error) {
      handleError('Error', 'Integration was not saved.');
    }
  }, [handleSubmit, reset, handleSuccess, handleError, active])

  if (!item) {
    return null
  }

  return <>
    <FormWrapper title='Integration'>
      <Heading data={item} active={active} onChangeActive={setActive} />
      <Form data={item} handleSubmit={handleSubmitAndRedirect} onCancel={handleClose} />
    </FormWrapper>
  </>
});

IntegrationForm.propTypes = IntegrationPropTypes
IntegrationForm.defaultProps = {}

export default function IntegrationFormLayout() {
  return <IntegrationProvider>
    <IntegrationForm />
  </IntegrationProvider>;
}
